import { createVNode as _createVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-25d62c18")

_pushScopeId("data-v-25d62c18")
const _hoisted_1 = { class: "exportPromptContainer" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, [
  /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "cloud_upload"),
  /*#__PURE__*/_createTextVNode(" Start live sync")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("b", null, "1."),
  /*#__PURE__*/_createTextVNode(" Select sync type:")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { for: "socket" }, [
  /*#__PURE__*/_createTextVNode("Socket "),
  /*#__PURE__*/_createVNode("i", null, "- Default (Works for most servers)")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { for: "manual" }, [
  /*#__PURE__*/_createTextVNode("Manual "),
  /*#__PURE__*/_createVNode("i", null, "- Use this when socket doesn't work")
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("b", null, "2."),
  /*#__PURE__*/_createTextVNode(" Enter your server address and the port configured for the sync socket (default 27757): ")
], -1)
const _hoisted_8 = { class: "address" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Run this command on your server: ")
const _hoisted_10 = { class: "command" }
const _hoisted_11 = {
  key: 0,
  class: "spin material-icons"
}
const _hoisted_12 = { class: "action-row" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "cloud_upload", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Connect live sync", -1)
const _hoisted_15 = { class: "action-row" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Close", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", {
    class: "exportPrompt",
    style: { display: _ctx.syncPromptOpen ? 'flex' : 'none' }
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createVNode("div", null, [
        _createVNode("div", null, [
          _withDirectives(_createVNode("input", {
            type: "radio",
            name: "syncType",
            id: "socket",
            value: _ctx.SyncType.SOCKET,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.syncType = $event))
          }, null, 8, ["value"]), [
            [
              _vModelRadio,
              _ctx.syncType,
              void 0,
              { number: true }
            ]
          ]),
          _hoisted_4
        ]),
        _createVNode("div", null, [
          _withDirectives(_createVNode("input", {
            type: "radio",
            name: "syncType",
            id: "manual",
            value: _ctx.SyncType.MANUAL,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.syncType = $event))
          }, null, 8, ["value"]), [
            [
              _vModelRadio,
              _ctx.syncType,
              void 0,
              { number: true }
            ]
          ]),
          _hoisted_5
        ])
      ]),
      (_ctx.syncType == _ctx.SyncType.SOCKET)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _withDirectives(_createVNode("input", {
                type: "text",
                placeholder: " hypixel.net:27757",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.serverAddress = $event))
              }, null, 512), [
                [_vModelText, _ctx.serverAddress]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("p", null, [
        _createVNode("b", null, _toDisplayString(_ctx.syncType == _ctx.SyncType.SOCKET ? "3" : "2") + ".", 1),
        _hoisted_9
      ]),
      _createVNode("div", _hoisted_10, [
        (!_ctx.syncKey)
          ? (_openBlock(), _createBlock("span", _hoisted_11, "autorenew"))
          : (_openBlock(), _createBlock("input", {
              key: 1,
              ref: "commandInput",
              type: "text",
              onInput: _cache[4] || (_cache[4] = $event => (_ctx.$refs.commandInput.value = _ctx.syncCommand)),
              value: _ctx.syncCommand
            }, null, 40, ["value"])),
        _createVNode("span", {
          class: "material-icons copyBtn",
          ref: "copyCommandIcon",
          onClick: _cache[5] || (_cache[5] = $event => (_ctx.copyCommand()))
        }, "content_copy", 512)
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("b", null, _toDisplayString(_ctx.syncType == _ctx.SyncType.SOCKET ? "4" : "3") + ".", 1),
        _createVNode("div", {
          class: ["btn export", 
            (!_ctx.serverAddress || !_ctx.syncKey) && _ctx.syncType == _ctx.SyncType.SOCKET
              ? 'inactive'
              : ''
          ],
          onClick: _cache[6] || (_cache[6] = $event => (_ctx.sync()))
        }, [
          _hoisted_13,
          _hoisted_14
        ], 2)
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode("div", {
          class: "btn close",
          onClick: _cache[7] || (_cache[7] = $event => (_ctx.syncPromptOpen = false))
        }, [
          _hoisted_16
        ])
      ])
    ])
  ], 4))
})